import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";

const Normativa = () => {
  const [activeTab, setActiveTab] = React.useState("fichajes");

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);

  const tabContent = {
    fichajes: (
      <div style={{ fontWeight: "400" }}>
        <h3 className="mb-3">Normativa de fichajes</h3>
        <p>
          En España, el registro de la jornada laboral es obligatorio y está
          reforzado por el Real Decreto-ley 8/2019. Debe reflejar con precisión
          la hora de inicio y finalización de la jornada de cada trabajador.
        </p>
        <p className="mb-2">
          <strong>Registro diario:</strong> debe realizarse todos los días, sin
          excepción.
        </p>
        <p className="mb-2">
          <strong>Contenido mínimo:</strong> entrada, salida y trazabilidad
          suficiente para acreditar la jornada efectivamente trabajada.
        </p>
        <p className="mb-2">
          <strong>Accesibilidad y transparencia:</strong> el registro debe estar
          disponible para trabajadores, su representación legal e Inspección de
          Trabajo.
        </p>
        <p className="mb-2">
          <strong>Confiabilidad e integridad:</strong> debe ser fiable, sin
          manipulaciones ni alteraciones.
        </p>
        <p className="mb-0">
          <strong>Totalización:</strong> en materia de horas extraordinarias, la
          empresa debe totalizar las horas del período y facilitar resumen junto
          al recibo salarial.
        </p>
      </div>
    ),
    horasExtra: (
      <div style={{ fontWeight: "400" }}>
        <h3 className="mb-3">Normativa de horas extra</h3>
        <p className="mb-2">
          <strong>Qué es una hora extraordinaria:</strong> toda hora de trabajo
          efectivo que exceda la jornada ordinaria máxima. Como referencia
          general, el Art. 34 del Estatuto de los Trabajadores fija un máximo de
          40 horas semanales de promedio anual y, por regla general, no más de 9
          horas diarias (salvo distribución irregular pactada).
        </p>
        <p className="mb-2">
          <strong>Regla general:</strong> son voluntarias, salvo pacto en
          convenio/contrato o supuestos de fuerza mayor (Art. 35 ET).
        </p>
        <p className="mb-2">
          <strong>Fuerza mayor:</strong> obligatorias para prevenir o reparar
          siniestros y daños urgentes; no computan para el límite anual, pero sí
          se compensan. El criterio técnico DGITSS n.º 85/2010 exige que el
          suceso sea imprevisible, inevitable e inimputable a la empresa.
        </p>
        <p className="mb-2">
          <strong>Límite anual:</strong> máximo 80 horas extra al año (con
          reducción proporcional en contratos de duración inferior al año).
        </p>
        <p className="mb-2">
          <strong>No computan para el límite:</strong> horas compensadas con
          descanso dentro de los 4 meses siguientes y horas por fuerza mayor.
        </p>
        <p className="mb-2">
          <strong>Compensación:</strong> por retribución o descanso equivalente,
          según convenio o contrato. Si no hay pacto expreso, se compensan con
          descanso dentro de los 4 meses siguientes.
        </p>
        <p className="mb-2">
          <strong>Retribución:</strong> nunca inferior al valor de la hora
          ordinaria. Para su cálculo, la jurisprudencia incluye salario base y
          complementos habituales, con matices para complementos de puesto
          (nocturnidad/festivos) cuando concurren esas circunstancias.
        </p>
        <p className="mb-2">
          <strong>Mejoras por convenio o norma aplicable:</strong> pueden fijar
          incrementos superiores; como referencia, en determinadas regulaciones
          sectoriales se contempla un recargo mínimo del 75% sobre la hora
          ordinaria.
        </p>
        <p className="mb-2">
          <strong>Doctrina judicial citada:</strong> STSJ Canarias 432/2014 y
          STSJ Madrid 1080/2012 y 1030/2012.
        </p>
        <p className="mb-2">
          <strong>Registro:</strong> la empresa debe garantizar registro diario
          de inicio y fin de jornada para el cómputo correcto. Además, debe
          totalizar las horas en el período de abono y entregar copia del
          resumen al trabajador junto al recibo salarial (criterio técnico OE
          ITSS 101/2019).
        </p>
        <p className="mb-0">
          <strong>Convenio colectivo:</strong> es clave y puede fijar importes
          superiores, descansos más favorables, límites adicionales o supuestos
          de obligatoriedad. El Art. 84 ET reconoce prioridad aplicativa del
          convenio de empresa en esta materia.
        </p>
      </div>
    ),
    permisos: (
      <div style={{ fontWeight: "400" }}>
        <h3 className="mb-3">Permisos laborales retribuidos</h3>
        <p className="mb-3">
          Formato resumen en estilo legal-documental. Aplicar siempre el
          convenio colectivo vigente cuando mejore estos mínimos.
        </p>
        <div className="table-responsive">
          <table className="table table-sm table-bordered align-items-center">
            <thead className="thead-light">
              <tr>
                <th>Motivo</th>
                <th>Duración</th>
                <th>Observaciones</th>
                <th>Base legal / jurisprudencia</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Matrimonio o registro de pareja de hecho</td>
                <td>15 días naturales</td>
                <td>
                  Si el hecho causante ocurre en día no laborable, el cómputo
                  inicia el primer día hábil siguiente.
                </td>
                <td>Art. 37 ET; SAN 13/2021; SAN 119/2021</td>
              </tr>
              <tr>
                <td>
                  Accidente, enfermedad grave, hospitalización o intervención
                  quirúrgica con reposo domiciliario
                </td>
                <td>5 días hábiles</td>
                <td>
                  Para cónyuge, pareja de hecho, parientes hasta 2.º grado y
                  convivientes que requieran cuidado efectivo.
                </td>
                <td>Art. 37 ET (redacción vigente)</td>
              </tr>
              <tr>
                <td>
                  Fallecimiento de cónyuge, pareja de hecho o parientes hasta
                  2.º grado
                </td>
                <td>2 días hábiles (4 con desplazamiento)</td>
                <td>
                  Ampliación por desplazamiento acreditado según práctica
                  convencional.
                </td>
                <td>Art. 37 ET</td>
              </tr>
              <tr>
                <td>Lactancia</td>
                <td>1 hora/día hasta 9 meses del lactante</td>
                <td>
                  Puede sustituirse por reducción de 1/2 hora o acumularse en
                  jornadas completas según convenio/acuerdo.
                </td>
                <td>Art. 37 ET; DF 1.ª conciliación</td>
              </tr>
              <tr>
                <td>Nacimiento de prematuros u hospitalización tras parto</td>
                <td>1 hora de ausencia; hasta 2 horas de reducción</td>
                <td>
                  La reducción adicional de jornada conlleva reducción
                  proporcional del salario.
                </td>
                <td>Art. 37 ET</td>
              </tr>
              <tr>
                <td>Permiso parental</td>
                <td>Hasta 8 semanas (continuas o discontinuas)</td>
                <td>
                  Para cuidado de hijo o menor acogido por más de un año, hasta
                  que cumpla 8 años.
                </td>
                <td>Normativa de conciliación vigente</td>
              </tr>
              <tr>
                <td>Traslado de domicilio habitual</td>
                <td>1 día</td>
                <td>Permiso retribuido por cambio de residencia habitual.</td>
                <td>Art. 37 ET</td>
              </tr>
              <tr>
                <td>Deber inexcusable de carácter público y personal</td>
                <td>Tiempo indispensable</td>
                <td>Jurado, comparecencia judicial, ejercicio de voto, etc.</td>
                <td>Art. 37 ET</td>
              </tr>
              <tr>
                <td>Funciones sindicales o de representación</td>
                <td>Tiempo legal o convencional</td>
                <td>
                  Conforme crédito horario y reglas de representación aplicables.
                </td>
                <td>ET + convenio colectivo</td>
              </tr>
              <tr>
                <td>Exámenes para título académico/profesional</td>
                <td>Tiempo indispensable</td>
                <td>
                  Aplica cuando los estudios se cursan con regularidad.
                </td>
                <td>Art. 23 ET</td>
              </tr>
              <tr>
                <td>Exámenes prenatales y preparación al parto</td>
                <td>Tiempo indispensable</td>
                <td>Siempre que deban realizarse dentro de la jornada.</td>
                <td>Art. 37 ET</td>
              </tr>
              <tr>
                <td>Asuntos particulares (empresa privada)</td>
                <td>No existe mínimo legal general</td>
                <td>
                  Solo procede si está reconocido expresamente en convenio o
                  política interna.
                </td>
                <td>Doctrina general ET</td>
              </tr>
              <tr>
                <td>Regla de inicio del cómputo</td>
                <td>Desde día laborable</td>
                <td>
                  Si el hecho causante ocurre en festivo/descanso, comienza el
                  siguiente día hábil.
                </td>
                <td>SAN 13/2021; SAN 119/2021</td>
              </tr>
              <tr>
                <td>Prohibición de penalización por disfrute de permisos</td>
                <td>No aplica reducción de incentivos por esta causa</td>
                <td>
                  Nulas cláusulas discriminatorias que penalicen conciliación o
                  IT en incentivos.
                </td>
                <td>SAN 4/2024</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ),
  };

  return (
    <>
      <div className="main-content">
        <div className="header bg-gradient-warning py-7 py-lg-8">
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Card>
              <CardHeader>
                <h1>Normativa</h1>
              </CardHeader>
              <CardBody>
                <Nav tabs className="mb-4">
                  <NavItem>
                    <NavLink
                      href="#"
                      className={activeTab === "fichajes" ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("fichajes");
                      }}
                    >
                      Normativa fichajes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={activeTab === "horasExtra" ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("horasExtra");
                      }}
                    >
                      Normativa horas extra
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={activeTab === "permisos" ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("permisos");
                      }}
                    >
                      Normativa permisos laborales
                    </NavLink>
                  </NavItem>
                </Nav>
                {tabContent[activeTab]}
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Normativa;
